import { styled } from '@mui/material';
export const LoadingWrapper = styled('div', { shouldForwardProp: (prop) => prop !== 'fullHeight' })(({ theme, fullHeight }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(3),
    padding: '.375rem',
    height: fullHeight ? '100%' : undefined,
}));
